export enum ENotificationTaskAction{
  route = "Route",
  rappel = "Rappel"
}